// extracted by mini-css-extract-plugin
module.exports = {"sekilasTextHeading":"Sekilas_sekilasTextHeading__nzxH4","sekilasHeadline":"Sekilas_sekilasHeadline__nH4Ic","box":"Sekilas_box__1U5YS","visual1":"Sekilas_visual1__3hTR9"};